import * as React from "react";
import { forwardRef } from "react";
const SvgSpinner = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={49} height={48} viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M45.5 24a21.001 21.001 0 0 1-42 0" stroke="#6750A4" strokeWidth={6} strokeLinecap="round" /><path d="M14.5 24a10 10 0 0 1 20 0" stroke="#9387B4" strokeWidth={6} strokeLinecap="round" /></svg>;
const ForwardRef = forwardRef(SvgSpinner);
export default ForwardRef;